<template>
<div id="mainFrame" style="display: flex; flex-direction: column; height: 100vh;">
  <v-row v-if="loadingProgress == 100">
    <v-col>
       <h1>Checkliste der Innovationsprozesse <v-icon color="primary"
                                                      @mouseover="showInfobox('Anleitung und Begleitung der innerbetrieblichen Steuerung sozialer Innovationsprozesse bei der Einführung digitaler Tools. Beinhaltet Informationen zum sozialen Innovationsmodell, Vorbereitungsfragen für eine optimale Begleitung des sozialen Innovationsprozessess, Checklisten für die verschiedenen Phasen des Modells, Übersicht über den aktuellen Stand der sozialen Innovation.', '25%')"
                                                      @mouseleave="hideInfobox()">mdi-information-outline</v-icon></h1>
      <InfoboxTooltip ref="infoBox"/>
    </v-col>
    <v-col class="text-right" style="align-self: center">
      <v-btn color="primary" elevation="0" @click="openChecklistDialog()">
        <v-icon color="#F5F5F5" medium>add</v-icon > Neue Checkliste
      </v-btn>
    </v-col>
  </v-row>
  <v-tabs left fixed-tabs v-model="tab" color="secondary">
    <v-tab id="tab" key="all">Alle Checklisten 
      <v-chip id="chip" color="white">{{ checklists != null ? checklists.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
    <v-tab id="tab" key="own">Meine Checklisten 
      <v-chip id="chip" color="white">{{ ownChecklists != null ? ownChecklists.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
    <v-tab id="tab" key="shared">Entwürfe
      <v-chip id="chip" color="white">{{ drafts != null ? drafts.length : '0'}}</v-chip>
      <v-spacer/>
    </v-tab>
  </v-tabs>
  <div style="flex: 1 1 auto; height: 100%;" >
  <v-data-table
        hide-default-footer
        :headers="headers"
        :items="retrieveChecklistItems()"
        disable-pagination
        :sort-by.sync="columnName"
        :sort-desc.sync="isDescending"
        class="border-bottom mb-10"
    >
    <template v-slot:body="{items}">
      <tbody>
        <tr v-for="item in items"
          :key="item.id"
          @mouseover="selectItem(item)"
          @mouseleave="unSelectItem(item)">
          <td style="width: 32vw;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <a v-bind="attrs"
                   v-on="on" @click="viewChecklist(item)">
                  {{ item.name }}
                </a>
              </template>
              <span v-if="item.description">{{ item.description }}</span>
              <span v-else>{{ item.name }}</span>
            </v-tooltip>
          </td>
          <td style="max-width:80px; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                      <span class="cursor-default" v-bind="attrs" v-on="on">
                        <v-avatar
                            color="gray_3"
                            size="32"
                            style="color: #fff;"
                        >{{initials(item.creator)}}</v-avatar>
                      </span>
              </template>
              <span>{{ item.creator }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span class="date cursor-default" v-bind="attrs" v-on="on" style="vertical-align: center;">{{ new
                Date(item.createdDate).toLocaleString('de-DE', {day: 'numeric', month: 'short', year: 'numeric'})
                  }}</span>
              </template>
              <span>{{ new Date(item.createdDate).toLocaleString('de-DE') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <span
                    v-bind="attrs"
                    v-on="on"
                    v-if="item.currentStep < JSON.parse(item.listSchema).length-1"
                    class="cursor-default">
                  <v-avatar color="gray_4" size="32" class="text-black mr-1">{{decodeStepValue(item.currentStep)
                    }}</v-avatar>
                  <span class="text-gray font-s text-medium">
                    {{decodeStepText(item.currentStep)}}
                  </span>
                </span>
                <span v-else class="text-gray font-s"><v-icon small color="tr_green">mdi-check</v-icon>Abgeschlossen
                </span>
              </template>
              <span v-if="item.currentStep < JSON.parse(item.listSchema).length-1">{{getChecklistStepDescription(item.currentStep)}}</span>
              <span v-else>Abgeschlossen</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip outlined :color="getColorLight(item.currentStepState)" v-bind="attrs" v-on="on">
    <!--              <span class="dot" :style="'background-color:'+getColor(item.currentStepState)"></span>-->
                  <v-icon small :color="getColor(item.currentStepState)" class="text-description">mdi-circle</v-icon>
                  <span class="text-description"
                        :style="'color:'+getColor(item.currentStepState)">&nbsp;{{item.currentStepState}}
                    %</span>
                </v-chip>
              </template>
              <span>Zeigt den aktuellen Status innerhalb Ihrer Phase an</span>
            </v-tooltip>
          </td>
          <td style="max-width: 80px;">
            <div v-if="item === selectedItem" class="d-flex">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="viewChecklist(item)" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon> </v-btn>
                </template>
                <span>Bearbeiten</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="gray" small text @click="removeChecklist(item)" v-bind="attrs"
                         v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                </template>
                <span>Löschen</span>
              </v-tooltip>
            </div>
          </td>
      </tr>
      </tbody>
    </template>
    </v-data-table>
  </div>
  <v-progress-linear
      :style="'position: absolute; left: 0; bottom: 0; display: '+(loadingProgress == 100 ? 'none;' :
      'block; z-index:99;')"
      color="gray accent-4"
      :indeterminate="loadingProgress == 100 ? false : true"
      height="4"
      :value="loadingProgress"
  ></v-progress-linear>
  <NewChecklistDialog ref="checklistDialog" />
  <InfoboxTooltip ref="infoBox"/>
</div>
</template>

<script>
import DataTable from '../../components/common/DataTable.vue';
import ConfirmDialog from "@/components/common/ConfirmDialog";
import checklistService from "./checklist-service.js"
import FormDialog from '@/components/common/FormDialog.vue';
import checklistGenerator from "@/components/checklistGenerator.js"
import NewChecklistDialog from './NewChecklistDialog.vue';
import InfoboxTooltip from '../../components/common/InfoboxTooltip.vue';
import {getChecklistStepDescription} from "@/components/util.js"
export default {
  components: {
    DataTable,
    FormDialog,
    NewChecklistDialog,
    InfoboxTooltip
},
  name: "Checklists",
  data() {
    return {
      checklists: [],
      loadingProgress: 0,
      tab: null,
      headers: [
          {
            text: 'Checklistenname',
            align: 'start',
            value: 'name',
          },
          { text: 'Ersteller', value: 'creator' },
          { text: 'Erstellt am', value: 'createdDate'},
          { text: 'Aktuelle Phase', value: 'currentStep'},
          { text: 'Status', value: 'currentStepState'},
          { text: 'Aktionen', value: 'actions'},
      ],
      selectedItem: null,
      columnName: 'creationDate',
      isDescending: true,
      steps: [
        {value: 1, text: "Zweck bestimmen"},
        {value: 2, text: "Gezielt vorbereiten"},
        {value: 3, text: "Weiter anpassen"},
        {value: 4, text: "Unternehmensweit verbreiten"},
        {value: 5, text: "Routinen neu etablieren"}
      ]
    };
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    ownChecklists(){
      /* if(this.processes == null) return [];
      if(this.processes.length > 0){
        return this.processes.filter(elem => elem.isOwn == true);
      } */
    },
    drafts(){
      /* if(this.processes == null) return [];
      if(this.processes.length > 0){
        return this.processes.filter(elem => elem.isOwn == false);
      } */
    }
  },
  mounted() {
    this.retrieveChecklists();
    // Set Table Header Max-Width
    let ths = document.querySelectorAll('th>span');
    for (let elem of ths) {
      if (elem.innerHTML.length > 18) {
        elem.parentElement.setAttribute("style", "display:flex;");
        elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
      }
    }
  },
  methods: {
    getChecklistStepDescription: getChecklistStepDescription,
    decodeStepText(currentStep){
      return this.steps.filter(e => e.value == currentStep)[0].text;
    },
    decodeStepValue(currentStep){
      return this.steps.filter(e => e.value == currentStep)[0].value;
    },
    showInfobox(desc, position) {
      this.$refs['infoBox'].open(desc, position);
    },
    hideInfobox() {
      this.$refs['infoBox'].close();
    },
    getColor(stepState){
        if(stepState <= 50) return "var(--red-color)";
        if(stepState > 50 && stepState < 100) return "var(--yellow-color)";
        if(stepState== 100) return "var(--green-color)";
        return "#BABABA";
    },
    getColorLight(stepState){
        if(stepState <= 50) return "var(--red-color_m)";
        if(stepState > 50 && stepState < 100) return "var(--yellow-color_m)";
        if(stepState== 100) return "var(--green-color_m)";
        return "#BABABA";
    },
    completionCount(list){
      let fieldCount = list.fields[1].options.length;
      let answeredCount = 0;
      list.fields[1].options.forEach(option => {
        if(option.answer == 2)  answeredCount += 1;
      })
      return parseInt((answeredCount / fieldCount) * 100);
    },
    openChecklistDialog(){
      this.$refs.checklistDialog
        .open("Bitte geben Sie Ihrer Checkliste einen Namen:")
        .then((checklistData) => {
          let checklistSchema = this.buildChecklist();
          checklistService.addChecklist(checklistData, checklistSchema).then(res => {
            this.$router.push({
              name: 'createList',
              params: {
                checklistTitle: checklistData.title,
                listId: res.data
              }
            });
          })
        });
    },
    retrieveChecklistItems(){
      if(this.tab == 0){
        return this.checklists;
      }else if( this.tab == 1){
        return this.ownChecklists;
      }else if(this.tab == 2){
        return this.drafts;
      }
    
    },
    retrieveChecklists() {
      this.loadingProgress = 0;
      this.checklists = [];
      checklistService.retrieveChecklists()
      .then(result => {
        this.checklists = result.data;
        this.checklists.forEach(list => {
          let listSchema = JSON.parse(list.listSchema);
          list.currentStep = listSchema.filter(elem => elem != null && this.completionCount(elem) == 100).length + 1;
          if(list.currentStep != null){
            if(list.currentStep > listSchema.length-1) {
              list.currentStepState = 100;
            }else{
              list.currentStepState = this.completionCount(listSchema[list.currentStep]);
            }
            
          }
          
          })
        this.loadingProgress = 100;
      });
 
    },
    viewChecklist(item){
      this.$router.push({name: 'answerList', params: { listId: item.id}})
    },
    buildChecklist(){
      let checklist = [];
      for(let i = 1; i <= 5; ++i){
        let stepSchema = checklistGenerator.getStepContent(i);
        checklist[i] = stepSchema;
      }
      return checklist;
      
    },
    removeChecklist(item){
      checklistService.deleteChecklistById(item.id).then(()=> this.retrieveChecklists());
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem(item) {
      this.selectedItem = false;
    },
    initials(email){
      let initials = email.substring(0,2).toUpperCase();
      return initials;
    }
  }
};
</script>
<style scoped>
.white{
  color: var(--v-secondary-base) !important;
}
.v-tab--active{
  color:initial;
}
.v-tab--active > .v-chip{
  background-color: var(--v-secondary-base) !important;
  color: #F5F5F5 !important;
}
#tab{
  max-width:unset;
}
#tab.active{
  font-size: 10rem;
}
#chip{
  margin-left: 10px;
}
#datatable{
  position: inherit !important;
}
.dot {
  height: 20px;
  width: 20px;
  margin: 2.5px;
  border-radius: 50%;
  display: inline-block;
}
.v-tooltip__content {
  max-width: 400px;

}
.callout-container{
  margin:5px 20px 30px 30px;
}
.callout .col {
  padding-top: 3vh;
}
:deep td:last-child button.v-size--small {
  min-width: unset;
  width: 36px;
}
:deep th {
  height: 60px !important;
}
</style>